export enum MessageObjectType {
  ELEMENT = "element",
  TASK = "task",
  ACTION_PLAN = "action_plan",
  KIT = "kit",
  GENERIC = "generic",
}

export const TEMP_THREAD_ID = "TEMP_THREAD_ID";
